import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Loading from '@/commons/loading';
import ElementUI from 'element-ui';
import Viewer from 'v-viewer';
import './assets/theme/index.css';
import './commons';
import { message } from './commons/message';
import AkPageList from './components/AkPageList';
import AkPageDetail from './components/AkPageDetail';

Vue.component('AkPageList', AkPageList);
Vue.component('AkPageDetail', AkPageDetail);
Vue.use(ElementUI);
Vue.use(Loading);
Vue.use(Viewer);
Vue.prototype.$message = message;

Vue.config.productionTip = false;

Viewer.setDefaults({
    navbar: false,
    title: false,
    movable: true,
    scalable: false,
    zIndex: 9999
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');

if (
    process.env.NODE_ENV === 'production' &&
    window.location.protocol === 'http:'
) {
    window.location.protocol = 'https:';
}
